<template>
  <div>
    <LoadingSpinner v-if="loading" />
    <div v-else class="card px-2 py-3 shadow-sm d-flex">
      <!-- Data -->
      <div class="col-12 mt-3" v-if="dataStatsOperators.length > 0">
        <div class="row">
          <div class="col-12">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th
                    v-for="(item, index) in dataStatsOperators.filter(
                      (e) => !e.totals
                    )"
                    :key="index"
                  >
                    {{ item.month }}
                  </th>
                  <th>Total AVG</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(title, index) in titles" :key="'row-' + index">
                  <td>{{ title.label }}</td>
                  <td
                    v-for="(item, idx) in dataStatsOperators"
                    :key="'cell-' + idx"
                  >
                    {{ item[title.id] !== null ? item[title.id] : "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usersService } from "@/_services";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "OperatorsAvgTime",

  components: {
    IndustrySearch,
    LoadingSpinner,
  },

  data() {
    return {
      loading: true,
      titles: [
        { id: "spark_first_sync", label: "Spark first sync" },
        { id: "spark_resync", label: "Spark re-sync" },
        { id: "blocked_outlook", label: "Blocked Outlook" },
        {
          id: "email_waiting_for_creation",
          label: "Emails waiting for creation",
        },
        { id: "domain_config", label: "Domain config" },
        { id: "by_domain", label: "By domain" },
        { id: "target_missing_data", label: "Target missing data" },
        { id: "target_contact_supply", label: "Target contact supply" },
        { id: "warmy", label: "Warmy" },
        {
          id: "commercial_without_prspectors",
          label: "Commercial without prospectors",
        },
        { id: "config_smtp", label: "Config SMTP" },
        {
          id: "client_without_oliver_sale",
          label: "Client without Oliver sale",
        },
        { id: "not_prospecting_sale", label: "Not prospecting sale" },
        { id: "client_attribution", label: "Client attribution" },
        { id: "burned_domains", label: "Burned domains" },
        { id: "phone_lookup", label: "Phone lookup" },
        { id: "orders_missing_email", label: this.$t("lang.orders.orders") + " missing email" },
        { id: "unverified_orders", label: "Unverified orders" },
        { id: "reported_orders", label: "Reported orders" },
      ],
      dataStatsOperators: [],
      gettingDataClientMonths: true,
    };
  },

  created() {
    this.init();
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
  },

  methods: {
    init() {
      this.getMonthOperators();
    },

    getMonthOperators() {
      this.gettingDataClientMonths = true;
      usersService
        .getStatsOperators()
        .then((ressult) => {
          const res = ressult.result;

          let totals = {};

          this.titles.forEach((title) => {
            const id = title.id;
            const filtered = res.filter((e) => e[id] !== undefined);
            const sum = filtered.reduce(
              (acc, val) => Number(acc) + Number(val[id]),
              0
            );
            const average = (sum / filtered.length).toFixed(2);

            totals[id] = average;
          });

          totals.totals = 1;

          ressult.result.push(totals);
          this.dataStatsOperators = ressult.result;
          this.loading = false;
        })
        .catch((err) => console.error(err));
    },
  },
};
</script>
